/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { faToilet } from '@fortawesome/free-solid-svg-icons/faToilet'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useIntl } from 'react-intl'
import { parseNumber } from '@jalik/form-parser'
import FormNumberField, {
  FormNumberFieldProps
} from '../../../../client/js/components/form/fields/FormNumberField'

function ToiletsField (props: FormNumberFieldProps) {
  const { name = 'toilets', ...others } = props
  const intl = useIntl()
  return (
    <FormNumberField
      label={intl.formatMessage({
        id: 'toilets',
        defaultMessage: 'Toilettes'
      })}
      name={name}
      parser={parseNumber}
      leftSection={(
        <FontAwesomeIcon
          fixedWidth
          icon={faToilet}
        />
      )}
      {...others}
    />
  )
}

export default ToiletsField
